import styled from 'styled-components';


export const Column = styled.div`
    padding-right: 10.5px;
    padding-left: 10.5px;
`;